"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatMessageContext } from "../contexts";
import Avatar from "@/components/ui/avatar";
interface AIChatMessageAvatarProps {
  firstName?: string;
  lastName?: string;
  className?: string;
}
export function AIChatMessageAvatar(t0) {
  const $ = _c(6);
  const {
    firstName,
    lastName,
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  if (message.role !== "user") {
    return null;
  }
  let t1;
  if ($[0] !== firstName || $[1] !== lastName) {
    t1 = [firstName, lastName].filter(Boolean);
    $[0] = firstName;
    $[1] = lastName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[3] !== className || $[4] !== t2) {
    t3 = <Avatar size="sm" variant="neutral" fallback={t2} className={className} />;
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}